import Logo from "../../images/VIBE-Logo-New.png";
import Irdai from "../../images/irda-logo.png";
export const Footer = () => {
  return (
    // <div className="footer container-fluid bg-dark text-light mt-5 p-3 mb-0">
    //     <div className=" ms-2"><b style={{ position: 'absolute' }}>Payment Methods</b><p className="text-end"><b> ㅤ   </b></p></div>
    //     <div className=" row ">
    //         <div className="container ">
    //             <div className="row ms-2">
    //                 <div className="col-sm-2 col-xs-3 col-md-2 col-lg-1">
    //                     <div className="card mt-3 "   >
    //                         <a href="#">
    //                             <div className="card-body text-center" >
    //                                 <img src={Visa6} />
    //                             </div>
    //                         </a>
    //                     </div>
    //                 </div>
    //                 <div className="col-sm-2 col-xs-3 col-md-2 col-lg-1">
    //                     <div className="card mt-3 "  >
    //                         <a href="#">
    //                             <div className="card-body text-center" >
    //                                 <img src={Visa4} />
    //                             </div>
    //                         </a>
    //                     </div>
    //                 </div>
    //                 <div className="col-sm-2 col-xs-3 col-md-2 col-lg-1">
    //                     <div className="card mt-3 "  >
    //                         <a href="#">
    //                             <div className="card-body text-center" >
    //                                 <img src={Visa3} />
    //                             </div>
    //                         </a>
    //                     </div>
    //                 </div>
    //                 <div className="col-sm-2 col-xs-3 col-md-2 col-lg-1">
    //                     <div className="card mt-3 " >
    //                         <a href="#">
    //                             <div className="card-body text-center" >
    //                                 <img src={Visa2} />
    //                             </div>
    //                         </a>
    //                     </div>
    //                 </div>
    //                 <div className="col-sm-2 col-xs-3 col-md-2 col-lg-1">
    //                     <div className="card mt-3 " >
    //                         <a href="#">
    //                             <div className="card-body text-center" >
    //                                 <img src={Visa1} />
    //                             </div>
    //                         </a>
    //                     </div>
    //                 </div>
    //                 <div className="col-sm-2 col-xs-3 col-md-2 col-lg-1">
    //                     <div className="card mt-3 "  >
    //                         <a href="#">
    //                             <div className="card-body text-center" >
    //                                 <img src={Visa7} />
    //                             </div>
    //                         </a>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    //     <div className="mt-2" style={{ textAlign: 'center', color: 'rgb(168, 168, 168)', fontSize: '12px' }} ><p className="text-white m-0">Contact Us | Legal and Admin Policies</p>
    //         <p className="pb-0 m-0">VIBE is now registered as a Direct Broker </p><p className="m-0">© Copyright 2022 VIBE.com. All Rights Reserved.</p></div>
    // </div>

    <footer style={{ background: "#000" }} className="footer text-white pt-5">
      <div className="px-5">
        <div className="footer-main-row">
          <div className="footer-section">
            <div>
              <a
                href="/"
                className="d-flex align-items-center mb-3 mb-md-0  text-decoration-none"
              >
                <img
                  className="logo-brand-img position-relative"
                  src={Logo}
                />
              </a>
              <p className="footer-desc">
                NO.33/54, <br />
                Mount Poonamalee Road,
                <br />
                Near Kathipara Flyover,
                <br />
                St. Thomas Mount,
                <br />
                Chennai - 600016
              </p>
            </div>
          </div>
          <div className="footer-section">
            <div>
              <h4 className="text-white">
                Vibe Insurance Broking And<br></br> Advisory Service Pvt Ltd
              </h4>
              <ul className="list-unstyled">
                <li className="my-2">
                  <p className="footer-desc mb-0">
                    IRDAI License No. 904,
                  </p>
                </li>
                <li className="my-2">
                  <p className="footer-desc mb-0">
                    Valid till date 03/07/2026.
                  </p>
                </li>
                <li className="my-2">
                  <p className="footer-desc mb-0">
                    Registration Code No. IRDAI/DB1027/2023
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-section">
            <div>
              <p className="text-white mb-2" style={{ fontSize: "14px", fontWeight: "800" }}>
                CIN -U67100TN2022PTC156408
              </p>
              <h4 className="text-white">
                Registered & <br></br>Corporate Office:
              </h4>
              <p className="footer-desc">
                NO.33/54, <br />
                Mount Poonamalee Road,
                <br />
                Near Kathipara Flyover,
                <br />
                St. Thomas Mount,
                <br />
                Chennai - 600016
              </p>
            </div>
          </div>
          <div className="footer-section">
            <div>
              <h4 className="text-white">
                Terms and policies
              </h4>
              <ul className="list-unstyled">
                <li className="my-2">
                  <a href="/contact-us" className="footer-prod-item">
                    Contact
                  </a>
                </li>
                <li className="my-2">
                  <a href="/disclaimer" className="footer-prod-item">
                    Disclaimer
                  </a>
                </li>
                <li className="my-2">
                  <a href="/privacy-policy" className="footer-prod-item">
                    Privacy Policy
                  </a>
                </li>
                <li className="my-2">
                  <a href="/terms-of-use" className="footer-prod-item">
                    Terms of use
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-section">
            <div>
              <h4 className="text-white">
                Principal Officer
              </h4>
              <ul className="list-unstyled">
                <li className="my-1">
                  <p className="footer-desc mb-1">Kameshwaran,</p>
                </li>
                <li className="my-1">
                  <p className="footer-desc mb-1">+917824077700</p>
                </li>
                <li className="my-1">
                  <p className="mb-1">
                    <a href="#" className="footer-prod-item">contact@vibeins.com</a>
                  </p>
                </li>
                <a
                  href="/"
                  className="irdai-sec text-decoration-none"
                >
                  <img
                    src={Irdai}
                    style={{ maxWidth: "125px" }}
                    alt="IRDAI Logo"
                  />
                </a>
              </ul>
            </div>
          </div>
        </div>

        <div className="row px-5 mt-4">
          <div className="col-12 text-center">
            <h4 className="text-white mb-2" style={{ fontSize: "20px", fontWeight: "600" }}>Disclaimer</h4>
            <p className="footer-desc mb-3" style={{ opacity: "0.8" }}>
              For comprehensive details on risk factors, terms, conditions, and exclusions, customers are advised to<br></br>
              carefully read the sales brochure of the respective insurer prior to concluding the sale.
            </p>
            <div className="regulatory-links d-flex justify-content-center gap-2 align-items-center">
              <a href="https://irdai.gov.in/home" target="_blank" rel="noreferrer" className="text-white text-decoration-none footer-prod-item">IRDAI</a>
              <span className="text-white opacity-50">|</span>
              <a href="https://ibai.org/" target="_blank" rel="noreferrer" className="text-white text-decoration-none footer-prod-item">IBAI</a>
              <span className="text-white opacity-50">|</span>
              <a href="https://policyholder.gov.in/" target="_blank" rel="noreferrer" className="text-white text-decoration-none footer-prod-item">Policy Holder</a>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-4 mb-3">
          <div className="copyright">
            <p>
              Copyright ©2026 Vibe Insurance Broking And Advisory Service Pvt
              Ltd
            </p>
          </div>
        </div>

      </div>
    </footer>
  );
};
